import { isNative } from "@stepapp/core";
import { useCallback } from "react";

export const useGTMDispatch = () => {
  const sendEvent = useCallback((params: object) => {
    if (__DEV__ || isNative) {
    }

    const dataLayer = (window as NotWorth)?.dataLayer;

    if (dataLayer) {
      dataLayer.push(params);
    }
  }, []);

  return useCallback(
    (params: object) => {
      if (__DEV__) {
      }

      sendEvent(params);
    },
    [sendEvent],
  );
};
